type BackendPermission = {
  subject: string;
  action: string[];
};

type FrontendPermission = {
  key: string;
  read?: boolean;
  manage?: boolean;
  create?: boolean;
  update?: boolean;
  delete?: boolean;
  review?: boolean;
  publish?: boolean;
};

export const mapBackendPermissions = (
  payload: BackendPermission[]
): FrontendPermission[] => {
  return payload?.map(p => {
    const permission: FrontendPermission = {
      key: p.subject.toLocaleLowerCase().trim(),
    };

    if (p.action.includes('manage')) {
      permission.manage = true;
    }

    if (p.action.includes('read') || p.action.includes('update') || p.action.includes('create') || p.action.includes('delete') || p.action.includes('view')) {
      permission.read = true;
    }
    if (p.action.includes('create')) permission.create = true;
    if (p.action.includes('update')) permission.update = true;
    if (p.action.includes('delete')) permission.delete = true;
    if (p.action.includes('review')) permission.review = true;
    if (p.action.includes('publish')) permission.publish = true;

    return permission;
  });
};
